import { Component, input } from '@angular/core';
import { BaseIconComponent } from './base-icon.component';

@Component({
  selector: 'lib-square-check-icon',
  template: `
    <svg
      xmlns="http://www.w3.org/2000/svg"
      [attr.width]="width()"
      [attr.height]="height()"
      viewBox="0 0 24 24"
      fill="none">
      <path
        d="M0 4C0 1.79086 1.79086 0 4 0H20C22.2091 0 24 1.79086 24 4V20C24 22.2091 22.2091 24 20 24H4C1.79086 24 0 22.2091 0 20V4Z"
        [attr.fill]="bgColor()" />
      <path
        d="M5 11.5L9.66118 16L19 7"
        [attr.stroke]="color()"
        stroke-width="1.5"
        stroke-linecap="round"
        stroke-linejoin="round" />
    </svg>
  `,
})
export class SquareCheckIconComponent extends BaseIconComponent {
  override width = input<string>('1.5rem');
  override height = input<string>('1.5rem');
  bgColor = input<string>('#F9FAFB');
  override color = input<string>('#6B7280');
}
